import React from 'react';

const s = {
  card:    { background: '#16161f', border: '1px solid #1e1e2e', borderRadius: 16, padding: 24, marginBottom: 20 },
  badge:   { display: 'inline-block', padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 700 },
  btn:     { padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13 },
  input:   { background: '#0f0f17', border: '1px solid #1e1e2e', borderRadius: 8, padding: '10px 14px', color: '#e8e8f0', width: '100%', fontSize: 14, boxSizing: 'border-box' },
  label:   { display: 'block', marginBottom: 6, fontSize: 12, color: '#6b6b80', fontWeight: 600 },
  table:   { width: '100%', borderCollapse: 'collapse' },
  th:      { textAlign: 'left', padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#6b6b80', textTransform: 'uppercase', borderBottom: '1px solid #1e1e2e' },
  td:      { padding: '12px 16px', fontSize: 14, borderBottom: '1px solid #1e1e2e' },
};

export const Card = ({ children, style }) => <div style={{ ...s.card, ...style }}>{children}</div>;

export const StatCard = ({ label, value, color = '#a29bfe', sub }) => (
  <div style={{ ...s.card, textAlign: 'center' }}>
    <div style={{ fontSize: 36, fontWeight: 700, color, lineHeight: 1.1 }}>{value}</div>
    <div style={{ fontSize: 13, color: '#6b6b80', marginTop: 6 }}>{label}</div>
    {sub && <div style={{ fontSize: 11, color: '#6b6b80', marginTop: 4 }}>{sub}</div>}
  </div>
);

export const Btn = ({ children, onClick, color = '#6c63ff', disabled, style }) => (
  <button
    style={{ ...s.btn, background: disabled ? '#2a2a3a' : color, color: disabled ? '#6b6b80' : '#fff', ...style }}
    onClick={onClick}
    disabled={disabled}
  >{children}</button>
);

export const Input = ({ label, value, onChange, placeholder, type = 'text', style }) => (
  <div style={{ marginBottom: 16, ...style }}>
    {label && <label style={s.label}>{label}</label>}
    <input style={s.input} type={type} value={value} onChange={onChange} placeholder={placeholder} />
  </div>
);

export const Badge = ({ label, color = '#a29bfe', bg = 'rgba(108,99,255,0.15)' }) => (
  <span style={{ ...s.badge, color, background: bg }}>{label}</span>
);

export const statusBadge = (status) => {
  const map = {
    ACTIVE:    { color: '#55efc4', bg: 'rgba(85,239,196,0.12)' },
    PAUSED:    { color: '#ffd200', bg: 'rgba(255,210,0,0.12)'   },
    INACTIVE:  { color: '#ff6584', bg: 'rgba(255,101,132,0.12)' },
    PENDING:   { color: '#ffd200', bg: 'rgba(255,210,0,0.12)'   },
    PAID:      { color: '#55efc4', bg: 'rgba(85,239,196,0.12)'  },
    NEW:       { color: '#74b9ff', bg: 'rgba(116,185,255,0.12)' },
    CONTACTED: { color: '#a29bfe', bg: 'rgba(162,155,254,0.12)' },
    CONVERTED: { color: '#55efc4', bg: 'rgba(85,239,196,0.12)'  },
    CLOSED:    { color: '#6b6b80', bg: 'rgba(107,107,128,0.12)' },
  };
  const c = map[status] || { color: '#6b6b80', bg: 'rgba(107,107,128,0.12)' };
  return <Badge label={status} color={c.color} bg={c.bg} />;
};

export const Table = ({ headers, rows }) => (
  <div style={{ overflowX: 'auto' }}>
    <table style={s.table}>
      <thead>
        <tr>{headers.map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  </div>
);

export const Loading = () => (
  <div style={{ textAlign: 'center', padding: 60, color: '#6b6b80' }}>⏳ Loading...</div>
);

export const Empty = ({ msg = 'কোনো data নেই' }) => (
  <div style={{ textAlign: 'center', padding: 60, color: '#6b6b80' }}>{msg}</div>
);

export const PageTitle = ({ title, sub }) => (
  <div style={{ marginBottom: 28 }}>
    <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>{title}</h1>
    {sub && <p style={{ color: '#6b6b80', margin: '6px 0 0', fontSize: 14 }}>{sub}</p>}
  </div>
);

export const Grid = ({ cols = 4, children }) => (
  <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 16, marginBottom: 24 }}>
    {children}
  </div>
);
